module.exports = __webpack_public_path__ + "static/media/macrometa-white-transparent.fe9af029.png";